export default {
    // 账号：pingtai2
    // 密码：123456
    // apiUrl:'http://192.168.0.199:96',    //本地
    // apiUrl:'http://test.suyuan.com', //测试
    apiUrl: 'https://console.trace.shangqiaokeji.top',    //线上
    // 账号：admin
    // 密码：123456
    // apiUrl:'https://guanyuinstr.cn',
    // apiUrl : `${location.origin}`,   //自动获取
}